// TODO: Add agent icon in library

import Typography from '@ixigo/iui/Typography';
import { TestId } from '../../enums/test';
import agent from '../../images/agent.svg';

type Props = {
    actorName: string;
};

function AgentAssignment({ actorName }: Props) {
    return (
        <div
            className='mx-20 my-5 p-10 text-purple-500 text-center bg-purple-50 border border-purple-200 rounded-10'
            data-testid={TestId.ASSIGNMENT}
        >
            <Typography className='flex gap-0.5 justify-center items-center'>
                <img src={agent} alt='assigned' />
                This conversation was
            </Typography>
            <Typography fontWeight='bold'>assigned to {actorName}</Typography>
        </div>
    );
}

export default AgentAssignment;
